export * from './api';
export type * from './api/types';
export * from './constants';
export * from './services';
export type * from './types';

// Factory function to create service objects with a custom API function
import { apiModel } from '@repo/api-model';
import {
  activateService,
  changePasswordService,
  createCustomerService,
  loginService,
  retrieveActivationService,
  retrieveChangeService,
} from './api';
import type {
  activateParams,
  changePasswordParams,
  createCustomerParams,
  loginParams,
  retrieveActivationParams,
  retrieveChangeParams,
} from './api/types';
import {
  confirmChangeEmailService,
  confirmChangePhoneService,
  creditService,
  creditsService,
  customerService,
  fileService,
  initChangeEmailService,
  initChangePhoneService,
  offersService,
  receiveMessageService,
} from './services';
import type {
  confirmChangeEmailParams,
  confirmChangePhoneParams,
  creditParams,
  fileParams,
  initChangeEmailParams,
  initChangePhoneParams,
  receiveMessageParams,
} from './types';

type apiResponseService<T> = import('@repo/api-model').apiResponse<T>;

export const createCustomerServices = (customerApi: <T>(options: apiModel) => Promise<apiResponseService<T>>) => ({
  // API services
  login: async (data: loginParams) => loginService(customerApi, data),
  createCustomer: async (data: createCustomerParams) => createCustomerService(customerApi, data),
  retrieveActivation: async (data: retrieveActivationParams) => retrieveActivationService(customerApi, data),
  activate: async (data: activateParams) => activateService(customerApi, data),
  retrieveChange: async (data: retrieveChangeParams) => retrieveChangeService(customerApi, data),
  changePassword: async (data: changePasswordParams) => changePasswordService(customerApi, data),

  // Services
  initChangeEmail: async (data: initChangeEmailParams) => initChangeEmailService(customerApi, data),
  confirmChangeEmail: async (data: confirmChangeEmailParams) => confirmChangeEmailService(customerApi, data),
  initChangePhone: async (data: initChangePhoneParams) => initChangePhoneService(customerApi, data),
  confirmChangePhone: async (data: confirmChangePhoneParams) => confirmChangePhoneService(customerApi, data),
  credits: async (options?: Omit<apiModel, 'baseUrl'>) => creditsService(customerApi, options),
  credit: async (id: creditParams['id']) => creditService(customerApi, id),
  offers: async (options?: Omit<apiModel, 'baseUrl'>) => offersService(customerApi, options),
  file: async ({ fileType, idSolicitud }: fileParams) => fileService(customerApi, { fileType, idSolicitud }),
  receiveMessage: async (data: receiveMessageParams) => receiveMessageService(customerApi, data),
  customer: async (options?: Omit<apiModel, 'baseUrl'>) => customerService(customerApi, options),
});
